import * as React from "react";
import { QuestionData } from "../lib/types";
import questionData from "../lib/nursing_year2_uk_500_mcq_bank.json";

interface QuestionProps {
  handleResponse: (wasCorrect: boolean) => void;
  questionNumber: number;
}

export const Question = (props: QuestionProps): React.JSX.Element => {
  const thisQuestion = (questionData as QuestionData).questions[
    props.questionNumber
  ];
  const [selectedOption, setSelectedOption] = React.useState<string | null>(
    null,
  );
  const handleOptionClick = (selected: string) => {
    setSelectedOption(selected);
  };
  const isCorrect = selectedOption === thisQuestion.correct_answer;
  const handleNextQuestion = () => {
    setSelectedOption(null);
    props.handleResponse(isCorrect);
  };
  return (
    <div className="vertical-stack">
      <div>Domain: {thisQuestion.domain}</div>
      <div>
        <b>{thisQuestion.question}</b>
      </div>
      {!selectedOption && (
        <div className="vertical-stack">
          <button onClick={() => handleOptionClick("A")}>
            A: {thisQuestion.options.A}
          </button>
          <button onClick={() => handleOptionClick("B")}>
            B: {thisQuestion.options.B}
          </button>
          <button onClick={() => handleOptionClick("C")}>
            C: {thisQuestion.options.C}
          </button>
          <button onClick={() => handleOptionClick("D")}>
            D: {thisQuestion.options.D}
          </button>
        </div>
      )}
      {selectedOption && (
        <div className="vertical-stack">
          <div>
            You selected: {selectedOption}&nbsp;
            {isCorrect ? "✅" : "❌"}
          </div>
          <div>
            Correct answer: {thisQuestion.correct_answer}:{" "}
            {
              thisQuestion.options[
                thisQuestion.correct_answer as "A" | "B" | "C" | "D"
              ]
            }
          </div>
          <div>Rationale: {thisQuestion.rationale}</div>
          <div>
            <button onClick={handleNextQuestion}>Next Question</button>
          </div>
        </div>
      )}
    </div>
  );
};
